// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__vy7y6","mainContent":"DashboardLayout_mainContent__sv7qF"};